// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ISFg","fullView":"styles_fullView__xsKvj"};